import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import placeholderImg from '@/assets/Severe_Fire_Danger_Index.png'
import { fireDangerWfasInfo } from '@/constants/layers/wfasLayerInfo'

export const fireDangerNA: LayerRaw = {
  id: 'FireDanger',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  title: {
    'en-US': 'Severe Fire Danger Index (SFDI)',
    'pt-BR': 'Índice de Perigo de Incêndio Grave (SFDI)',
    'es-ES': 'Índice de Peligro de Incendio Grave (SFDI)',
    'fr-FR': "Indice de danger d'incendie grave (SFDI)"
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: true,
  opacity: 0.5,
  customProperties: { group: 'riskLayers', img: placeholderImg, info: fireDangerWfasInfo },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'wfas:Severe_Fire_Danger_Index',
      visible: true,
      legend: {
        title: {
          'en-US': 'Severe Fire Danger Index (SFDI)',
          'pt-BR': 'Índice de Perigo de Incêndio Grave (SFDI)',
          'es-ES': 'Índice de Peligro de Incendio Grave (SFDI)',
          'fr-FR': "Indice de danger d'incendie grave (SFDI)"
        },
        items: [
          {
            text: {
              'en-US': 'Low',
              'es-ES': 'Bajo',
              'pt-BR': 'Baixo',
              'fr-FR': 'Bas'
            },
            color: '#2b83ba',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': 'Moderate',
              'es-ES': 'Moderado',
              'pt-BR': 'Moderado',
              'fr-FR': 'Modéré'
            },
            color: '#abdda4',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': 'High',
              'es-ES': 'Alto',
              'pt-BR': 'Alto',
              'fr-FR': 'Élevé'
            },
            color: '#ffffbf',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': 'Very High',
              'es-ES': 'Muy Alto',
              'pt-BR': 'Muito Alto',
              'fr-FR': 'Très élevé'
            },
            color: '#fdae61',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': 'Severe',
              'es-ES': 'Severo',
              'pt-BR': 'Severo',
              'fr-FR': 'Sévère'
            },
            color: '#d7191c',
            icon: 'mdi-square'
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley'
} as LayerRaw
